import { FC, ReactNode } from "react"
import { Brand } from "../../../types"
import BrandAutocomplete from "../brand-autocomplete"

interface Props {
  brands: Brand[]
  selectedBrandId: string
  onBrandChange: (id: string) => void
  /** Optional actions rendered beside the brand selector (e.g. Add button). */
  actions?: ReactNode
  children: ReactNode
}

const ConfigListShell: FC<Props> = ({
  brands,
  selectedBrandId,
  onBrandChange,
  actions,
  children
}) => (
  <div>
    {actions ? (
      <div className="flex items-center gap-3 mb-6">
        <BrandAutocomplete
          brands={brands}
          selected={selectedBrandId}
          hideLabel
          onChange={onBrandChange}
        />
        {actions}
      </div>
    ) : (
      <BrandAutocomplete
        brands={brands}
        selected={selectedBrandId}
        hideLabel
        onChange={onBrandChange}
      />
    )}

    <div className="pt-6">{children}</div>
  </div>
)

export default ConfigListShell
